module.exports = __webpack_public_path__ + "static/media/logo-comune-messina.03c3d6fe.png";